'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = (0, _glamorous2.default)('hr')(function (_ref) {
  var theme = _ref.theme;
  return {
    borderTop: theme.border,
    margin: theme.space_sm + ' 0'
  };
});